export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyBbc3C3K0E5_cAYNs5TQw6QdjvJXFITnnk",
        authDomain: "d-insle-sprungbrett-8f2t5.firebaseapp.com",
        databaseURL: "https://d-insle-sprungbrett-8f2t5.firebaseio.com",
        projectId: "d-insle-sprungbrett-8f2t5",
        storageBucket: "d-insle-sprungbrett-8f2t5.appspot.com",
        messagingSenderId: "262661208283",
        appId: "1:262661208283:web:fbd6b08fc6480f538974fe",
        measurementId: "G-EK8B1TDFF2"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts